// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__1E1to","password":"PasswordResetForm_password__3Knjk"};